import { supabase } from './supabase.js';

/**
 * Tiendas partner (rol store) disponibles para checkout «Partner verificador».
 * @returns {Promise<{ stores: Array<object>, error: string|null }>}
 */
export async function fetchVerifierStoresForCheckout(listingId = null, buyerDeliveryMode = null) {
  const params = {};
  if (listingId) params.p_listing_id = String(listingId).trim();
  if (buyerDeliveryMode) params.p_buyer_delivery_mode = String(buyerDeliveryMode).trim();
  const { data, error } = await supabase.rpc('list_verifier_stores_for_checkout', params);
  if (error) {
    console.error('[verifierStoresService]', error.message);
    return { stores: [], error: error.message };
  }
  return { stores: Array.isArray(data) ? data : [], error: null };
}

export function formatVerifierStoreLabel(store) {
  if (!store) return 'Tienda verificadora';
  const name = String(store.company_name || store.code || 'Tienda').trim();
  const city = String(store.city || '').trim();
  return city ? `${name} · ${city}` : name;
}
